// utils/learning/pageLifeCycle.js
// 页面生命周期钩子：切后台只做快照落盘。
// 不 abort、不 cancel —— 后端生成 task 独立于连接继续跑并缓存，
// 用户回来后由 _onPageVisible → resumeFromBackend 走 /resume-stream 续传。
import { forceSnapshotAll } from './backgroundFlow';

let _started = false;

export function initPageLifeCycle() {
  if (_started) return;
  _started = true;

  const onHidden = () => forceSnapshotAll();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') onHidden();
  });
  window.addEventListener('pagehide', onHidden);
  document.addEventListener('freeze', onHidden);
}
